import { createSlice } from "@reduxjs/toolkit";
import cookie from "react-cookies";


const initialState = {
    status: 'initial',
    errorMessage: '',
    templates: [],
}

const templateReducer = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loadingTemplates(state) {
            state.status = 'loading';
            state.templates = [];
        },
        successTemplates(state, action) {
            state.status = 'success';
            state.templates = action.payload;
        },
        failedTemplates(state, action) {
            state.status = 'error';
            state.errorMessage = action.payload?.message;
            state.user = action.payload;
        },
    },
});

export default templateReducer.reducer;

export const { loadingTemplates,successTemplates, failedTemplates } = templateReducer.actions;